
import { useEffect } from "react";
import { lazy, Suspense } from "react";
import FaqSkeleton from "../components/common/faq/faqSkeleton";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
import MorePage from "../components/common/sideNavbar/morePage";
import useOnboarding from "../hooks/useOnboarding";
import UserRefreshLogin from "../hooks/useRefreshLogin";
import useScreenResolution from "../hooks/useScreenResolution";
import Layout from "../layout/Layout";
import ActionScreens from "../pages/actions/actionScreens";
import ExpressShieldPlan from "../pages/buyOnline/expressShield/expressShieldPlan";
import Dashboard from "../pages/dashboard/dashboard";
import MobilePolicyTransferRequest from "../pages/dashboard/mobilePolicyTransferRequest";
import NewDomesticHelperPolicy from "../pages/domesticHelperPages/newDomesticHelperPolicy/NewDomesticHelperPolicy";
import EmergencyServices from "../pages/emergencyServices/EmergencyServices";
import EssentialCare from "../pages/essentialCare/essentialCare";
import PolicyOverviewMainTab from "../pages/essentialCare/policyOverview/policyOverviewMainTab";
import FileClaim from "../pages/fileClaim/fileClaim";
import NewHomePolicy from "../pages/homeInsurancePages/newHomePolicy/NewHomePolicy";
import FundManagementPage from "../pages/lifeInsurancePages/PolicyOverview/fundManagementTab/investementStrategyFlow/fundManagementPage";
import FundsRedirectingFlow from "../pages/lifeInsurancePages/PolicyOverview/fundManagementTab/investementStrategyFlow/fundsRedirectingFlow/fundsRedirectingFlow";
import FundsSwitchingFlow from "../pages/lifeInsurancePages/PolicyOverview/fundManagementTab/investementStrategyFlow/fundSwitchingFlow/fundSwitchingFlow";
import InvestmentStrategyChangeFlow from "../pages/lifeInsurancePages/PolicyOverview/fundManagementTab/investmentStrategyChangeFlow/investmentStrategyChangeFlow";
import ManageBeneficiaiaries from "../pages/lifeInsurancePages/PolicyOverview/manageMyPolicy/manageBeneficiaries/manageBeneficiaiaries";
import SurrenderPolicyFlow from "../pages/lifeInsurancePages/PolicyOverview/manageMyPolicy/surrenderPolicyFlow/surrenderPolicyFlow";
import WithdrawalFlow from "../pages/lifeInsurancePages/PolicyOverview/manageMyPolicy/withdrawalFlow/withdrawalFlow";
import PolicyOverview from "../pages/lifeInsurancePages/PolicyOverview/PolicyOverview";
import MobileChangePasswordPage from "../pages/mobileMorePages/mobileChangePassword";
import MobileNotificationScreen from "../pages/mobileMorePages/mobileNotificationScreen";
import MobileProfilePage from "../pages/mobileMorePages/mobileProfilePage";
import MobileSecurityPage from "../pages/mobileMorePages/mobileSecurityPage";
import AddMoreCoversMotorPolicy from "../pages/motorInsurancePages/addMOreCoversFlow/addMoreCoversMotorPolicy";
import AdjustSumInsuredMotorPolicy from "../pages/motorInsurancePages/adjustSumInsuredFlow/adjustSumInsuredMotorPolicy";
import ChangePlanPolicy from "../pages/motorInsurancePages/changePlanMotorPolicy/changePlanPolicy";
import ChangePlateNumberFlow from "../pages/motorInsurancePages/changePlateNumberFlow/changePlateNumberFlow";
import ChangePlateNumberPopup from "../pages/motorInsurancePages/changePlateNumberFlow/changePlateNumberPopup";
import FileClaimMotorPolicy from "../pages/motorInsurancePages/fileAClaimFlow/fileClaimMotorPolicy";
import NewMotorPolicy from "../pages/motorInsurancePages/newMotorPolicy/NewMotorPolicy";
import PaymentMethods from "../pages/motorInsurancePages/newMotorPolicy/pay/paymentMethods";
import PaymentSuccess from "../pages/motorInsurancePages/newMotorPolicy/pay/paymentSuccess";
import PolicyDocs from "../pages/motorInsurancePages/newMotorPolicy/pay/policyDocs";
import MobileUploadCarPhotos from "../pages/motorInsurancePages/newMotorPolicy/uploads/mobileUploadPages/mobileUploadCarPhotos";
import PolicyCancellationMotorInsurance from "../pages/motorInsurancePages/policyOverview/managePolicy/policyCancellationFlow/policyCancellationMotorInsurance";
import PolicyDetailsPage from "../pages/motorInsurancePages/policyOverview/policyDetailsPage";
import RemoveBankNameFlow from "../pages/motorInsurancePages/removeBankNameFlow/removeBankNameFlow";
import QuickRenewalMotorPolicy from "../pages/motorInsurancePages/renewalMotorPolicy/quickRenewalMotorPolicy";
import RenewalMotorPolicy from "../pages/motorInsurancePages/renewalMotorPolicy/renewalMotorPolicy";
import ChangeGaragePage from "../pages/motorInsurancePages/trackClaimFlow/claimComponents/changeGaragePage";
import ClaimDetailModal from "../pages/motorInsurancePages/trackClaimFlow/claimComponents/claimDetailModal";
import ClaimFileUploadHistory from "../pages/motorInsurancePages/trackClaimFlow/claimComponents/ClaimFileUploadHistory";
import ConfirmPaymentDetails from "../pages/motorInsurancePages/trackClaimFlow/claimComponents/confirmPaymentDetails";
import ReasonforReection from "../pages/motorInsurancePages/trackClaimFlow/claimComponents/reasonforReection";
import SuccessScreen from "../pages/motorInsurancePages/trackClaimFlow/claimComponents/successScreen";
import UploadDocuments from "../pages/motorInsurancePages/trackClaimFlow/claimComponents/uploadDocuments";
import ClaimProgressPage from "../pages/motorInsurancePages/trackClaimFlow/claimProgressPage";
import TrackClaimFlow from "../pages/motorInsurancePages/trackClaimFlow/trackClaimFlow";
import ConfirmTransferDetails from "../pages/motorInsurancePages/transferPolicyFlow/newOwner/confirmTransferDetails";
import TransferPolicyFlow from "../pages/motorInsurancePages/transferPolicyFlow/transferPolicyFlow";
import TransferSigninPage from "../pages/motorInsurancePages/transferPolicyFlow/transferSigninPage";
import ExpiredPoliciesPage from "../pages/myPoliciesPage/expiredPolicyPage";
import MyPoliciesPage from "../pages/myPoliciesPage/myPoliciesPage";
import NewPolicy from "../pages/newPolicy/newPolicy";
import NonMotorPolicyDetailsPage from "../pages/nonMotorPages/nonMotorPolicyDetailsPage";
import TravelPolicyDetailsPage from "../pages/travelInsurancePages/travelPolicyDetailsPage";
// Travel Insurance Endorsement Flows
import ChangePlanTravel from "../pages/travelInsurancePages/endorsements/changePlan/changePlanTravel";
import AddMoreCoversTravel from "../pages/travelInsurancePages/endorsements/addMoreCovers/addMoreCoversTravel";
import AddPassengerTravel from "../pages/travelInsurancePages/endorsements/addPassenger/addPassengerTravel";
import ModifyPassengerTravel from "../pages/travelInsurancePages/endorsements/modifyPassenger/modifyPassengerTravel";
import ChangeTripDateTravel from "../pages/travelInsurancePages/endorsements/changeTripDate/changeTripDateTravel";
import CancelPolicyTravel from "../pages/travelInsurancePages/endorsements/cancelPolicy/cancelPolicyTravel";
// Domestic Helper Insurance
import DomesticHelperPolicyDetailsPage from "../pages/domesticHelperPages/policyOverview/domesticHelperPolicyDetailsPage";
import CancelPolicyDomesticHelper from "../pages/domesticHelperPages/endorsements/cancelPolicy/cancelPolicyDomesticHelper";
// Smart Device Insurance
import SmartDevicePolicyDetailsPage from "../pages/smartDeviceInsurancePages/policyOverview/smartDevicePolicyDetailsPage";
import CancelPolicySmartDevice from "../pages/smartDeviceInsurancePages/endorsements/cancelPolicy/cancelPolicySmartDevice";
// Cyber Security Insurance
import CyberSecurityPolicyDetailsPage from "../pages/personalCyberInsurancePages/policyOverview/cyberSecurityPolicyDetailsPage";
import CancelPolicyCyberSecurity from "../pages/personalCyberInsurancePages/endorsements/cancelPolicy/cancelPolicyCyberSecurity";
// Home Insurance
import HomeInsurancePolicyDetailsPage from "../pages/homeInsurancePages/policyOverview/homeInsurancePolicyDetailsPage";
import CancelPolicyHomeInsurance from "../pages/homeInsurancePages/endorsements/cancelPolicy/cancelPolicyHomeInsurance";
// Personal Accident Insurance
import PersonalAccidentPolicyDetailsPage from "../pages/personalAccidentInsurancePages/policyOverview/personalAccidentPolicyDetailsPage";
import CancelPolicyPersonalAccident from "../pages/personalAccidentInsurancePages/endorsements/cancelPolicy/cancelPolicyPersonalAccident";
// Personal Cyber Insurance
import CancelPolicyPersonalCyber from "../pages/personalCyberInsurancePages/endorsements/cancelPolicy/cancelPolicyPersonalCyber";
import OnboardingScreen from "../pages/onboardingPages/onboardingScreen";
import NewPersonalAccidentPolicy from "../pages/personalAccidentInsurancePages/newPersonalAccidentPolicy/NewPersonalAccidentPolicy";
import NewPersonalCyberPolicy from "../pages/personalCyberInsurancePages/newPersonalCyberPolicy/NewPersonalCyberPolicy";
import ReportRedirect from "../pages/policyReport/ReportRedirect";
import ProfileSettings from "../pages/profileSettings/profileSettings";
import Activation from "../pages/SBdrive/activation";
import Success from "../pages/SBdrive/Success";
import ChangeEmailFlow from "../pages/signInRegisterPages/changeEmailFlow/changeEmailFlow";
import ChangeMobileNumberFlow from "../pages/signInRegisterPages/changeMobileNumberFlow/changeMobileNumberFlow";
import ForgotPassword from "../pages/signInRegisterPages/ForgotPasswordPage/ForgotPassword";
import MainSignupPage from "../pages/signInRegisterPages/mainSignupPage";
import SignInPage from "../pages/signInRegisterPages/SignInPage/SignInPage";
import NewSmartDevicePolicy from "../pages/smartDeviceInsurancePages/newSmartDevicePolicy/NewSmartDevicePolicy";
import NewTravelPolicy from "../pages/travelInsurancePages/newBniTravelPolicy/NewTravelPolicy";
import NewAmanPolicy from "../pages/amanInsurancePages/newAmanPolicy/NewAmanPolicy";
import AmanPolicyDetailsPage from "../pages/amanInsurancePages/policyOverview/AmanPolicyDetailsPage";
// Generic Renewal Pages
import RenewalHub from "../pages/renewalPages/RenewalHub";
import RenewalTravelPolicy from "../pages/renewalPages/travelRenewal/RenewalTravelPolicy";
import RenewalHomePolicy from "../pages/renewalPages/homeRenewal/RenewalHomePolicy";
import RenewalDomesticHelperPolicy from "../pages/renewalPages/domesticHelperRenewal/RenewalDomesticHelperPolicy";
import RenewalPersonalCyberPolicy from "../pages/renewalPages/personalCyberRenewal/RenewalPersonalCyberPolicy";
import RenewalPersonalAccidentPolicy from "../pages/renewalPages/personalAccidentRenewal/RenewalPersonalAccidentPolicy";
import { selectLoginTokenInfo } from "../redux/features/loginRegisterSlice";
import { fetchProfileInfo } from "../redux/features/profileSlice";
import NotFoundPage from "./notFoundPage";


const FaqPage = lazy(() => import("../pages/dashboard/faqPage"));
const MobileFaqPage = lazy(() => import("../pages/mobileMorePages/mobileFaqPage"));
// Stable component defined OUTSIDE AllRoutes to prevent remounting on parent re-render
const AuthorizedRoute = ({ children }) => {
  const loginTokenInfo = useSelector(selectLoginTokenInfo);
  if (!loginTokenInfo) {
    return <Navigate to="/" replace />;
  }
  return children;
};

const AllRoutes = () => {
  UserRefreshLogin();
  useOnboarding();
  const screenResolution = useScreenResolution();

  let routes = [
    {
      path: "/sign-in",
      element: <SignInPage />,
      isPopup: true,
      hide_header: true,
      isAuthorized: false,
    },
    {
      path: "/forgot-password",
      element: <ForgotPassword />,
      isPopup: true,
      hide_header: false,
      isAuthorized: false,
    },
    {
      path: "/profile-details",
      element: <MobileProfilePage />,
      isPopup: true,
      hide_header: true,
      isAuthorized: true,
    },
    {
      path: "/notifications",
      element: <MobileNotificationScreen />,
      isPopup: true,
      hide_header: true,
      isAuthorized: true,
    },
    {
      path: "/change-password",
      element: <MobileChangePasswordPage />,
      isPopup: true,
      hide_header: true,
      isAuthorized: true,
    },
    {
      path: "/security",
      element: <MobileSecurityPage />,
      isPopup: true,
      hide_header: true,
      isAuthorized: true,
    },
    {
      path: "/sign-up",
      element: <MainSignupPage />,
      isPopup: true,
      hide_header: true,
      isAuthorized: false,
    },
    {
      path: "/",
      element: <Dashboard />,
      hide_header: false,
      isPopup: false,
      isAuthorized: false,
    },
    {
      path: "/policyTransfer/:id",
      element: screenResolution.mobile ? (
        <MobilePolicyTransferRequest />
      ) : (
        <Dashboard />
      ),
      hide_header: false,
      isPopup: false,
      isAuthorized: true,
    },
    {
      path: "/policyTransfer/signin/:id",
      element: <TransferSigninPage />,
      hide_header: true,
      isPopup: false,
      isAuthorized: true,
    },
    {
      path: "/more",
      element: <MorePage />,
      hide_header: false,
      isPopup: false,
      isAuthorized: false,
    },
    {
      path: "/faq",
      element: (
        <Suspense fallback={<FaqSkeleton />}>
          {screenResolution.mobile ? <MobileFaqPage /> : <FaqPage />}
        </Suspense>
      ),
      hide_header: screenResolution.mobile ? true : false,
      isPopup: screenResolution.mobile ? true : false,
      isAuthorized: false,
    },
    {
      path: "/my-policy",
      element: <MyPoliciesPage />,
      hide_header: false,
      isPopup: false,
      // Open to visitors. AuthorizedRoute redirected them to "/" instead, so
      // the page could not say why it was empty or offer a way in; it now
      // renders a placeholder pointing at sign-in. Nothing behind it leaks:
      // MyPolicies only fetches when there is a token.
      isAuthorized: false,
    },
    {
      path: "/life-insurance/policy-overview",
      element: <PolicyOverview />,
      hide_header: screenResolution.mobile,
      isPopup: false,
      isAuthorized: true,
    },
    {
      path: "/profile-settings",
      element: <ProfileSettings />,
      isAuthorized: true,
    },
    {
      path: "/new-policy",
      element: <NewPolicy />,
      hide_header: screenResolution.mobile,
      isAuthorized: false,
    },
    {
      path: "/emergency-services",
      element: <EmergencyServices />,
      isAuthorized: false,
    },
    {
      path: "/file-a-claim",
      element: <FileClaim />,
      isAuthorized: false,
    },
    {
      path: "/onboarding-flow",
      element: <OnboardingScreen />,
      hide_header: true,
      isPopup: true,
      isAuthorized: false,
    },
    {
      path: "/actions",
      element: <ActionScreens />,
      hide_header: true,
      isPopup: false,
      isAuthorized: false,
    },
    {
      path: "/change-mobile-number",
      element: <ChangeMobileNumberFlow />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    {
      path: "/change-email",
      element: <ChangeEmailFlow />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    {
      path: "/expired-policies",
      element: <ExpiredPoliciesPage />,
      hide_header: screenResolution.mobile,
      isPopup: false,
      isAuthorized: true,
    },
    {
      path: "/essential-care",
      element: <EssentialCare />,
      isPopup: true,
      hide_header: false,
      isAuthorized: false,
    },
    {
      path: "/essential-care/policy-overview",
      element: <PolicyOverviewMainTab />,
      hide_header: screenResolution.mobile ? true : false,
      isPopup: false,
      isAuthorized: true,
    },
  ];

  let motorRoutes = [
    // new Motor Policy routes
    {
      path: "/new-motor-policy",
      element: <NewMotorPolicy />,
      isPopup: true,
      hide_header: true,
      isAuthorized: false,
    },
    {
      path: "/new-travel-policy",
      element: <NewTravelPolicy />,
      isPopup: true,
      hide_header: true,
      isAuthorized: false,
    },
    {
      path: "/motor-insurance/policy-overview/:policy_id",
      element: <PolicyDetailsPage />,
      hide_header: screenResolution.mobile ? true : false,
      isPopup: false,
      isAuthorized: true,
    },
    {
      path: "/general-insurance/policy-overview/:policy_id",
      element: <NonMotorPolicyDetailsPage />,
      hide_header: screenResolution.mobile ? true : false,
      isPopup: false,
      isAuthorized: true,
    },
    {
      path: "/travel-insurance/policy-overview/:policy_id",
      element: <TravelPolicyDetailsPage />,
      hide_header: screenResolution.mobile ? true : false,
      isPopup: false,
      isAuthorized: true,
    },
    // Travel Insurance Endorsement Flow Routes
    {
      path: "/travel-insurance/change-plan/:policy_id",
      element: <ChangePlanTravel />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    {
      path: "/travel-insurance/add-more-covers/:policy_id",
      element: <AddMoreCoversTravel />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    {
      path: "/travel-insurance/add-passenger/:policy_id",
      element: <AddPassengerTravel />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    {
      path: "/travel-insurance/modify-passenger/:policy_id",
      element: <ModifyPassengerTravel />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    {
      path: "/travel-insurance/change-trip-date/:policy_id",
      element: <ChangeTripDateTravel />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    {
      path: "/travel-insurance/cancel-policy/:policy_id",
      element: <CancelPolicyTravel />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    // Domestic Helper Insurance Routes
    {
      path: "/domestic-helper-insurance/policy-overview/:policy_id",
      element: <DomesticHelperPolicyDetailsPage />,
      hide_header: screenResolution.mobile ? true : false,
      isPopup: false,
      isAuthorized: true,
    },
    {
      path: "/domestic-helper-insurance/policy-overview/:policy_id/:tabType",
      element: <DomesticHelperPolicyDetailsPage />,
      hide_header: screenResolution.mobile ? true : false,
      isPopup: false,
      isAuthorized: true,
    },
    // Domestic Helper Insurance Endorsement Flow Routes
    {
      path: "/domestic-helper-insurance/endorsements/cancel-policy/:policy_id",
      element: <CancelPolicyDomesticHelper />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    // Smart Device Insurance Routes
    {
      path: "/smart-device-insurance/policy-overview/:policy_id",
      element: <SmartDevicePolicyDetailsPage />,
      hide_header: screenResolution.mobile ? true : false,
      isPopup: false,
      isAuthorized: true,
    },
    {
      path: "/smart-device-insurance/policy-overview/:policy_id/:tabType",
      element: <SmartDevicePolicyDetailsPage />,
      hide_header: screenResolution.mobile ? true : false,
      isPopup: false,
      isAuthorized: true,
    },
    // Smart Device Insurance Endorsement Flow Routes
    {
      path: "/smart-device-insurance/endorsements/cancel-policy/:policy_id",
      element: <CancelPolicySmartDevice />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    // Personal Cyber Insurance Routes (for existing personal cyber policies)
    {
      path: "/personal-cyber/policy-overview/:policy_id",
      element: <CyberSecurityPolicyDetailsPage />,
      hide_header: screenResolution.mobile ? true : false,
      isPopup: false,
      isAuthorized: true,
    },
    {
      path: "/personal-cyber/policy-overview/:policy_id/:tabType",
      element: <CyberSecurityPolicyDetailsPage />,
      hide_header: screenResolution.mobile ? true : false,
      isPopup: false,
      isAuthorized: true,
    },
    // Personal Cyber Insurance Endorsement Flow Routes
    {
      path: "/personal-cyber/endorsements/cancel-policy/:policy_id",
      element: <CancelPolicyPersonalCyber />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    // Cyber Security Insurance Routes
    {
      path: "/cyber-security-insurance/policy-overview/:policy_id",
      element: <CyberSecurityPolicyDetailsPage />,
      hide_header: screenResolution.mobile ? true : false,
      isPopup: false,
      isAuthorized: true,
    },
    {
      path: "/cyber-security-insurance/policy-overview/:policy_id/:tabType",
      element: <CyberSecurityPolicyDetailsPage />,
      hide_header: screenResolution.mobile ? true : false,
      isPopup: false,
      isAuthorized: true,
    },
    // Cyber Security Insurance Endorsement Flow Routes
    {
      path: "/cyber-security-insurance/endorsements/cancel-policy/:policy_id",
      element: <CancelPolicyCyberSecurity />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    // Home Insurance Routes
    {
      path: "/home-insurance/policy-overview/:policy_id",
      element: <HomeInsurancePolicyDetailsPage />,
      hide_header: screenResolution.mobile ? true : false,
      isPopup: false,
      isAuthorized: true,
    },
    {
      path: "/home-insurance/policy-overview/:policy_id/:tabType",
      element: <HomeInsurancePolicyDetailsPage />,
      hide_header: screenResolution.mobile ? true : false,
      isPopup: false,
      isAuthorized: true,
    },
    // Home Insurance Endorsement Flow Routes
    {
      path: "/home-insurance/endorsements/cancel-policy/:policy_id",
      element: <CancelPolicyHomeInsurance />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    // Personal Accident Routes
    {
      path: "/personal-accident/policy-overview/:policy_id",
      element: <PersonalAccidentPolicyDetailsPage />,
      hide_header: screenResolution.mobile ? true : false,
      isPopup: false,
      isAuthorized: true,
    },
    {
      path: "/personal-accident/policy-overview/:policy_id/:tabType",
      element: <PersonalAccidentPolicyDetailsPage />,
      hide_header: screenResolution.mobile ? true : false,
      isPopup: false,
      isAuthorized: true,
    },
    // Personal Accident Endorsement Flow Routes
    {
      path: "/personal-accident/endorsements/cancel-policy/:policy_id",
      element: <CancelPolicyPersonalAccident />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    {
      path: "/motor-insurance/payment",
      element: <PaymentMethods />,
      hide_header: true,
      isPopup: true,
      isAuthorized: true,
    },
    {
      path: "new-motor-policy/upload-photos-of-car/:id",
      element: <MobileUploadCarPhotos />,
      hide_header: true,
      isPopup: true,
      isAuthorized: true,
    },
    // renewal Motor plicy routes
    // Generic Renewal Hub
    {
      path: "/renew",
      element: <RenewalHub />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    // Motor renewal under generic hub (redirects to existing motor renewal)
    {
      path: "/renew/renew-motor-policy",
      element: <RenewalMotorPolicy />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    // Travel renewal placeholder
    {
      path: "/renew/renew-travel-policy",
      element: <RenewalTravelPolicy />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    // Home renewal placeholder
    {
      path: "/renew/renew-home-policy",
      element: <RenewalHomePolicy />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    // Domestic Helper renewal placeholder
    {
      path: "/renew/renew-domestic-helper-policy",
      element: <RenewalDomesticHelperPolicy />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    // Personal Cyber renewal placeholder
    {
      path: "/renew/renew-personal-cyber-policy",
      element: <RenewalPersonalCyberPolicy />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    // Personal Accident renewal placeholder
    {
      path: "/renew/renew-personal-accident-policy",
      element: <RenewalPersonalAccidentPolicy />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    // Legacy motor renewal route (backwards compatibility)
    {
      path: "/motor-insurance/renew-motor-policy",
      element: <RenewalMotorPolicy />,
      isPopup: true,
      hide_header: false,
      isAuthorized: false,
    },
    {
      path: "/motor-insurance/quick-renew-motor-policy",
      element: <QuickRenewalMotorPolicy />,
      isPopup: true,
      hide_header: false,
      isAuthorized: false,
    },
    // change plan Motor plicy routes
    {
      path: "/motor-insurance/change-plan/:policy_id",
      element: <ChangePlanPolicy />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    // add more covers Motor plicy routes
    {
      path: "/motor-insurance/add-more-covers/:policy_id",
      element: <AddMoreCoversMotorPolicy />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    // track a Claim routes
    {
      path: "/motor-insurance/track-claim",
      element: <TrackClaimFlow />,
      isPopup: true,
      hide_header: false,
      isAuthorized: false,
    },
    // file new claim routes
    {
      path: "/motor-insurance/file-new-claim",
      element: <FileClaimMotorPolicy />,
      isPopup: true,
      hide_header: false,
      isAuthorized: false,
    },
    // transfer Ownership
    {
      path: "/motor-insurance/transfer-ownership",
      element: <TransferPolicyFlow />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    {
      path: "/motor-insurance/confirm-transfer-details",
      element: <ConfirmTransferDetails />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    {
      path: "/motor-insurance/remove-bank-name/:policy_id",
      element: <RemoveBankNameFlow />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    {
      path: "/motor-insurance/claim-details/historydoc/:claim_id",
      element: <ClaimFileUploadHistory />,
      isPopup: true,
      hide_header: false,
      isAuthorized: false,
    },
    {
      path: "/motor-insurance/claim-details/offer/:claim_id",
      element: <ClaimFileUploadHistory />,
      isPopup: true,
      hide_header: false,
      isAuthorized: false,
    },
    {
      path: "/motor-insurance/change-plate-number",
      element: <ChangePlateNumberFlow />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    {
      path: "/motor-insurance/sbdriveactivation",
      element: <Activation />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    {
      path: "/motor-insurance/payment-success",
      element: <PaymentSuccess />,
      isPopup: true,
      hide_header: true,
      isAuthorized: true,
    },
    {
      path: "/motor-insurance/sbdrive-activated",
      element: <Success />,
      isPopup: true,
      hide_header: true,
      isAuthorized: true,
    },
    {
      path: "/life-insurance/payment-success",
      element: <PaymentSuccess />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    {
      path: "/motor-insurance/adjust-sum-insured/:policy_id",
      element: <AdjustSumInsuredMotorPolicy />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    {
      path: "/insurance-policies/policy-documents",
      element: <PolicyDocs />,
      isPopup: true,
      hide_header: false,
      isAuthorized: false,
    },
    {
      path: "/policy/report",
      element: <ReportRedirect />,
      isPopup: true,
      hide_header: false,
      isAuthorized: false,
    },
    {
      path: "/motor-insurance/cancel-policy/:policy_id",
      element: <PolicyCancellationMotorInsurance />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    {
      path: "/motor-insurance/claim-details/:claim_id",
      element: <ClaimProgressPage />,
      isPopup: false,
      hide_header: screenResolution.mobile,
      isAuthorized: false,
    },
    {
      path: "/motor-insurance/change-garage/:claim_id",
      element: <ChangeGaragePage />,
      isPopup: true,
      hide_header: false,
      isAuthorized: false,
    },
    {
      path: "/motor-insurance/upload-documents/:claim_id",
      element: <UploadDocuments />,
      isPopup: true,
      hide_header: false,
      isAuthorized: false,
    },
    {
      path: "/motor-insurance/payment-details/:claim_id",
      element: <ConfirmPaymentDetails />,
      isPopup: true,
      hide_header: false,
      isAuthorized: false,
    },
    {
      path: "/motor-insurance/success",
      element: <SuccessScreen />,
      isPopup: true,
      hide_header: false,
      isAuthorized: false,
    },
    {
      path: "/motor-insurance/claim-details/claim-info/:claim_id",
      element: <ClaimDetailModal />,
      isPopup: true,
      hide_header: false,
      isAuthorized: false,
    },
    {
      path: "/motor-insurance/reason-for-rejection/:claim_id",
      element: <ReasonforReection />,
      isPopup: true,
      hide_header: false,
      isAuthorized: false,
    },
    {
      path: "/motor-insurance/change-plate-number-modal",
      element: <ChangePlateNumberPopup />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
  ];

  let lifeInsuranceRoutes = [
    {
      path: "/life-insurance/withdraw",
      element: <WithdrawalFlow />,
      hide_header: false,
      isPopup: true,
      isAuthorized: true,
    },
    {
      path: "/life-insurance/surrender-policy",
      element: <SurrenderPolicyFlow />,
      hide_header: false,
      isPopup: true,
      isAuthorized: true,
    },
    {
      path: "/life-insurance/manage-beneficiaries",
      element: <ManageBeneficiaiaries />,
      hide_header: screenResolution.mobile,
      isPopup: false,
      isAuthorized: true,
    },
    {
      path: "/life-insurance/investement-strategy-change",
      element: <InvestmentStrategyChangeFlow />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    {
      path: "/life-insurance/fund-management",
      element: <FundManagementPage />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    {
      path: "/life-insurance/funds-redirecting-flow",
      element: <FundsRedirectingFlow />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
    {
      path: "/life-insurance/funds-switching-flow",
      element: <FundsSwitchingFlow />,
      isPopup: true,
      hide_header: false,
      isAuthorized: true,
    },
  ];

  let buyOnlineRoutes = [
    {
      path: "/buy-online/express-shield",
      element: <ExpressShieldPlan />,
      isPopup: true,
      hide_header: true,
      isAuthorized: false,
    },
    // Domestic Helper Policy Routes
    {
      path: "/new-domestic-helper-policy",
      element: <NewDomesticHelperPolicy />,
      isPopup: true,
      hide_header: true,
      isAuthorized: false,
    },
    // Home Policy Routes
    {
      path: "/new-home-policy",
      element: <NewHomePolicy />,
      isPopup: true,
      hide_header: true,
      isAuthorized: false,
    },
    // Personal Accident Policy Routes
    {
      path: "/new-personal-accident-policy",
      element: <NewPersonalAccidentPolicy />,
      isPopup: true,
      hide_header: true,
      isAuthorized: false,
    },
    // Personal Cyber Policy Routes
    {
      path: "/new-personal-cyber-policy",
      element: <NewPersonalCyberPolicy />,
      isPopup: true,
      hide_header: true,
      isAuthorized: false,
    },
    // Smart Device Policy Routes
    {
      path: "/new-smart-device-policy",
      element: <NewSmartDevicePolicy />,
      isPopup: true,
      hide_header: true,
      isAuthorized: false,
    },
    // Aman Insurance Policy Routes
    {
      path: "/new-aman-policy",
      element: <NewAmanPolicy />,
      isPopup: true,
      hide_header: true,
      isAuthorized: false,
    },
    {
      path: "/aman-insurance/policy-overview/:policy_id",
      element: <AmanPolicyDetailsPage />,
      isPopup: false,
      hide_header: screenResolution.mobile ? true : false,
      isAuthorized: true,
    },
  ];
  const loginTokenInfo = useSelector(selectLoginTokenInfo);
  const dispatch = useDispatch();

  useEffect(() => {
    if (loginTokenInfo) {
      dispatch(fetchProfileInfo());
    }
  }, [loginTokenInfo]);

  return (
    <Routes>
      {routes.map((route, index) => (
        <Route
          key={index}
          path={route.path}
          element={
            route.isAuthorized ? (
              <AuthorizedRoute>
                <Layout
                  isPopup={route.isPopup}
                  isHideHeader={route.hide_header}
                >
                  {route.element}
                </Layout>
              </AuthorizedRoute>
            ) : (
              <Layout isPopup={route.isPopup} isHideHeader={route.hide_header}>
                {route.element}
              </Layout>
            )
          }
        />
      ))}
      {[...motorRoutes, ...lifeInsuranceRoutes, ...buyOnlineRoutes].map(
        (route, index) => (
          <Route
            key={index}
            path={route.path}
            element={
              route.isAuthorized ? (
                <AuthorizedRoute>
                  <Layout
                    isPopup={route.isPopup}
                    isHideHeader={route.hide_header}
                  >
                    {route.element}
                  </Layout>
                </AuthorizedRoute>
              ) : (
                <Layout
                  isPopup={route.isPopup}
                  isHideHeader={route.hide_header}
                >
                  {route.element}
                </Layout>
              )
            }
          />
        )
      )}
      <Route
        path="*"
        element={
          <Layout isPopup={true} isHideHeader={false} invalidPage={true}>
            <NotFoundPage />
          </Layout>
        }
      />
    </Routes>
  );
};

export default AllRoutes;
